import { QuoteSetupItems } from '@/models/cart'
import { Service } from '@/models/service'
import { getBoughtServicesTotal } from './timeSchedules'

export function getGroupBoughtQuantity({
  groupId,
  ticketServices,
  selectedElementQuotableProducts,
  selectedService,
}: {
  groupId: number
  ticketServices: Service[]
  selectedElementQuotableProducts: QuoteSetupItems
  selectedService?: {
    service: Service
    bought: number
  }
}) {
  const groupedServicesIds = ticketServices
    .filter((ticket) => ticket.serviceGroupId === groupId)
    .map((ticket) => ticket.serviceId)

  const { boughtServices } = selectedElementQuotableProducts

  const total = Object.keys(boughtServices).reduce((carry, key) => {
    const serviceId = Number(key)

    if (serviceId === selectedService?.service.serviceId) {
      // SKIP, the amount is in the `selectedService.bought`
      return carry
    }

    if (groupedServicesIds.includes(serviceId)) {
      return carry + getBoughtServicesTotal(boughtServices[serviceId])
    }

    return carry
  }, 0)

  return selectedService ? total + selectedService.bought : total
}
